import { render, staticRenderFns } from "./ScoutingReportMatrix.vue?vue&type=template&id=8ccb8bdc&scoped=true&"
import script from "./ScoutingReportMatrix.vue?vue&type=script&lang=ts&"
export * from "./ScoutingReportMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./ScoutingReportMatrix.vue?vue&type=style&index=0&id=8ccb8bdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccb8bdc",
  null
  
)

export default component.exports